'use client';

import { FC, useEffect } from 'react';
import { useClientTranslation } from '@lib/i18n/client';
import * as Sentry from '@sentry/nextjs';
import { DashboardError } from '@tuic/web-compositions/my-trips/DashboardError';
import { Trans } from '@tuic/i18n';
import Link from 'next/link';
export type ErrorProps = {
  error: Error & {
    digest?: string;
    detail?: string;
    useReset?: boolean;
  };
  reset: () => void;
};
export const Error: FC<ErrorProps> = ({
  error,
  reset
}) => {
  const {
    t
  } = useClientTranslation();
  useEffect(() => {
    Sentry.setTag('total-crash', true);
    Sentry.captureException(error);
  }, [error]);
  return <div className="my-10" data-sentry-component="Error" data-sentry-source-file="error.tsx">
      <DashboardError headline={t('Leider gibt es aktuell technische Probleme.')} subline={<Trans>
            Leider haben wir aktuell technische Probleme. Bitte versuchen Sie es
            in ein paar Minuten noch einmal.
            <br />
            Wir bedauern diesen Zustand und danken für Ihr Verständnis!
          </Trans>} signature={t('Ihr Mein Schiff Team')} cta={{
      asChild: true,
      children: error.useReset ? <a onClick={reset}>{t('Zurück')}</a> : <Link href="/">{t('Zur Startseite')}</Link>
    }} errorInfo={error.digest && `#${error.digest}`} errorDetail={error.detail} data-sentry-element="DashboardError" data-sentry-source-file="error.tsx" />
    </div>;
};